export function ticketStatusColor(status) {
    switch (status) {
        case 'waiting':
            return 'warning';
        case 'in_progress':
            return 'info';
        case 'follow_up':
            return 'secondary';
        case 'closed_success':
            return 'success';
        case 'closed_unsuccessful':
            return 'default';
        default:
            return 'default';
    }
}

/** Canal padrão da abertura pelo dashboard web. */
export const TICKET_CHANNEL_WEB = 'web';
export const TICKET_CHANNEL_DESKTOP = 'desktop';

export function ticketChannelLabel(channel, fallbackLabel = '') {
    if (fallbackLabel) {
        return fallbackLabel;
    }
    switch (channel) {
        case TICKET_CHANNEL_DESKTOP:
            return 'FarmLink Desktop';
        case TICKET_CHANNEL_WEB:
        default:
            return 'Aplicação Web';
    }
}

export function isTicketClosed(status) {
    return status === 'closed_success' || status === 'closed_unsuccessful';
}

export function formatBytes(bytes) {
    const n = Number(bytes) || 0;
    if (n < 1024) return `${n} B`;
    if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
    return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

export const TICKET_ACCEPT =
    '.jpg,.jpeg,.png,.gif,.webp,.bmp,.mp4,.mov,.webm,.avi,.mkv,.log,.txt,.json,.csv,.md,.stl,.obj,.3mf,.pdf,.zip,.rar,.7z';

export async function filesToTicketPayload(files) {
    const list = Array.isArray(files) ? files : [];
    return Promise.all(list.map(async (file) => {
        const buffer = await file.arrayBuffer();
        const bytes = new Uint8Array(buffer);
        let binary = '';
        bytes.forEach((b) => {
            binary += String.fromCharCode(b);
        });
        return {
            file_name: file.name,
            content_type: file.type || 'application/octet-stream',
            data: btoa(binary),
        };
    }));
}
